import { api } from '../baseApi';
import { makeRequest } from '../makeRequest';
import { WorkspaceTypeID } from '../workspaces/dto';
import {
  FilterConfigNames,
  type GetFilterConfigQueryResponse,
  type GetFilterConfigRequest,
  type GetFilterConfigResponse,
} from './dto';
import { FilterConfigAPIRoutes } from './route';

export const FilterConfigNameById: Record<WorkspaceTypeID, FilterConfigNames | null> = {
  [WorkspaceTypeID.HCPExplorer]: FilterConfigNames.HCPExplorer,
  [WorkspaceTypeID.HCPExpansion]: FilterConfigNames.HCPExpansion,
  [WorkspaceTypeID.Throtle]: FilterConfigNames.Throtle,
  [WorkspaceTypeID.ListMatching]: null,
  [WorkspaceTypeID.DTC]: FilterConfigNames.DTC,
  [WorkspaceTypeID.MediaEffectiveness]: null,
  [WorkspaceTypeID.HCPSiteAnalytics]: FilterConfigNames.HCPSiteAnalytics,
  [WorkspaceTypeID.ListMatchingConsent]: null,
  [WorkspaceTypeID.BrandExplorer]: FilterConfigNames.BrandExplorer,
  [WorkspaceTypeID.MedscapeSoftMatch]: null,
};

export async function fetchFilterConfig(body: GetFilterConfigRequest): Promise<GetFilterConfigQueryResponse> {
  const { workspaceTypeId = WorkspaceTypeID.HCPExplorer } = body;

  // Default to HCPExplorer if no workspaceTypeId is provided or if it's not supported
  const isTypeIdSupported = workspaceTypeId && !!FilterConfigNameById[workspaceTypeId];
  const actualWorkspaceTypeId = isTypeIdSupported ? workspaceTypeId : WorkspaceTypeID.HCPExplorer;
  const params = {
    ...body,
    workspaceTypeID: actualWorkspaceTypeId,
  };

  const response = await makeRequest<GetFilterConfigResponse>(
    api.get(FilterConfigAPIRoutes.getFilterConfig(), { params }),
  );

  return {
    filterConfig: response.configuration,
  };
}
